// AdminRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function AdminRoute({ children }) {
  const { user, loadingAuth } = useAuth();

  if (loadingAuth) {
    return <p>⏳ Verifica autenticazione...</p>; // oppure uno spinner
  }

  if (!user?.accessToken) {
    
    return <Navigate to="/login" replace />;
  }

  if (user.ruolo !== "ROLE_ADMIN") {
    
    if (user.ruolo === "ROLE_STAFF") return <Navigate to="/gestionale1" replace />;
    if (user.ruolo === "ROLE_GENITORE") return <Navigate to="/gestionale2" replace />;
    return <Navigate to="/" replace />;
  }

  return children;
}
